import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useEffect
} from "react";
import { withRouter } from "react-router-dom";

import merge from "deepmerge";
import { IntlProvider } from "react-intl";

import {
  Button,
  Card,
  Title,
  Input,
  Select,
  RadioGroup,
  Icon,
  ButtonAction,
  Table,
  FormGroup,
  ContentBlock,
  StatusDot
} from "xsolla-uikit";

import CardNew from "./PAcardNew";

// import PAgameKeysWidg from "./PAgameKeysWidg";

import { ContextConsumer, GlobalContext } from './PA';

import { Link } from "react-router-dom";

import { KeyContext } from "./gk/PAgameKeys";

import { GameKeyWizard_temp } from "./gk/PAgcGameKeyWizard";

import { WidgetWizard } from "./gk/PAgcWidgetWizard";

import PAsbStartPopup from "./PAsbStartPopup";

export const PAgkDashboard3 = props => {
  let globalContext = useContext(GlobalContext);
  return <PAgkDash {...props} globalContext={globalContext} />;
};

const PAgkDash = withRouter(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        newKey: props.newKey || false,
        newWidget: props.newWidget || false,
        newSite: props.newSite || false
      };
      this.handleURL = this.handleURL.bind(this);
      // this.props.globalContext = props.globalContext || null
    }

    handleModal = (e, newState = !this.state.newKey) => {
      let date = new Date();
      let timestamp = date.getTime();
      let newKeysArray = this.getGameKeysArray();
      this.setState(
        {
          newKey: newState,
          keysArray: newKeysArray
        },
        () => {
          this.forceUpdate();
        }
      );
    };

    handleURL = function(sku) {
      return this.props.history.push(`/game_keys/${sku}`);
    };

    getGameKeysArray = (
      gameKeys = this.props.globalContext.globalState.store.gameKeys.keys
    ) => {
      // debugger
      if (!gameKeys) {
        gameKeys = this.props.globalContext
          ? this.props.globalContext.globalState.store.gameKeys.keys
          : {};
      }

      let a = [];

      if (gameKeys) {
        Object.keys(gameKeys).map((oneKeyName, i) => {
          a.push({
            ...gameKeys[oneKeyName]
          });
        });
      }
      return a;
    };

    renderKeyData = (what = "sku", oneKey) => {
      let keyData = oneKey.keyData;

      switch (what) {
        case "name":
          return <span>{keyData.general.name.value}</span>;
          break;

        case "sku":
          return (
            <div className="ui-mike-sku">
              {oneKey.keyData.general.sku.value}
            </div>
          );
          break;

        case "prices":
          return (
            <div>
              {keyData.curs.map(oneCur => {
                return (
                  <div>
                    {oneCur["curr"]} {oneCur["price"]}
                  </div>
                );
              })}
            </div>
          );
          break;

        case "status":
          return oneKey.storeGK === "ready" ? (
            <div style={{ display: "flex" }}>
              <StatusDot status="enabled">Selling</StatusDot>
              {/* <StatusDot status="enabled" style={{ marginRight: 12 }} /> */}
              {/* &nbsp;&nbsp;Selling */}
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <StatusDot status="testing">Draft</StatusDot>
              {/* <StatusDot status="testing" style={{ marginRight: 12 }} /> */}
              {/* &nbsp;&nbsp;Draft */}
            </div>
          );
          break;
      }
    };

    componentDidUpdate() {
      if (this.props.match.path === "/game_keys/newkey" && !this.state.newKey) {
        this.setState({
          newKey: true,
          newWidget: false,
          newSite: false
        });
      }

      if (
        this.props.match.path === "/game_keys/newwidget" &&
        !this.state.newWidget
      ) {
        this.setState({
          newKey: false,
          newWidget: true,
          newSite: false
        });
      }

      if (
        this.props.match.path === "/game_keys/newsite" &&
        !this.state.newSite
      ) {
        this.setState({
          newKey: false,
          newWidget: false,
          newSite: true
        });
      }

      if (
        this.props.match.path === "/game_keys" &&
        (this.state.newKey || this.state.newWidget || this.state.newSite)
      ) {
        this.setState({
          newKey: false,
          newWidget: false,
          newSite: false
        });
      }

      // if (this.props.newKey && !this.state.newKey) {
      //   this.setState(
      //     {
      //       newKey: true,
      //       newWidget: false
      //     },
      //     () => {
      //       console.log("this.state.newKey = ", this.state.newKey);
      //     }
      //   );
      // }
    }

    render() {
      return (
        <div className="xsui-content-block">

<FormGroup indentation="xs">


                  <div className="xsui-breadcrumbs_entry">
                    <div className="xsui-breadcrumbs_item">
                      <Link
                        className="xsui-breadcrumbs_label"
                        to="/launcher/"
                      >
                        <h1>Premium Games</h1>
                      </Link>
                      <div className="xsui-breadcrumbs_chevron">
                        <i
                          className="xsui-icon xsui-icon-chevron"
                          style={{
                            fontSize: 24,
                            color: "inherit"
                          }}
                        />
                      </div>
                    </div>

                  </div>

                {/* <div className="">
                    <Link
                        className="xsui-breadcrumbs_label"
                        to="/site_builder/new"
                      >
                        <Button appearance="secondary">Create new launcher</Button>
                      </Link>
                </div> */}


        </FormGroup>


          <div className="ui-navigation__menu">




            <FormGroup indentation="lg">
              <div className="ui-navigation__section">
                <Link
                  className="ui-navigation__item ui-navigation__item--active"
                  to="/game_keys"
                >
                  All Assets
                </Link>
                <Link className="ui-navigation__item" to="/game_keys">
                  Active (1)
                </Link>
                <Link className="ui-navigation__item" to="/game_keys">
                  Drafts (5)
                </Link>
              </div>
            </FormGroup>
            <div className="ui-navigation__section ui-navigation__section--actions" />
          </div>

          {this.props.globalContext && (
            <FormGroup>
              <FormGroup indentation="md">
                {Object.keys(
                  this.props.globalContext.globalState.store.gameKeys.keys
                ).length && (
                  <div
                    style={{
                      display: "grid",
                      // gridTemplateColumns: "32.3% 32.3% 32.3%",
                      // gridTemplateRows: '200px 200px',
                      gridColumnGap: "1.6%",
                      gridRowGap: "40px",
                      width: "100%"
                    }}
                  >
                    {this.getGameKeysArray({
                      ...this.props.globalContext.globalState.store.gameKeys
                        .keys
                    }).map((oneKey, i) => {
                      return (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 2fr",
                            // gridTemplateRows: '200px 200px',
                            gridColumnGap: "1.6%",
                            gridRowGap: "20px",
                            width: "100%"
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "200px",
                              cursor: "pointer"
                            }}
                            key={`${i}_onekey`}
                            onClick={e => {
                              this.handleURL(oneKey.keyData.general.sku.value);
                            }}
                          >
                            <CardNew>
                              <FormGroup indentation="sm">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    width: "100%"
                                  }}
                                >
                                  {this.renderKeyData("status", oneKey)}
                                  {this.renderKeyData("sku", oneKey)}
                                </div>
                              </FormGroup>
                              <FormGroup indentation="sm">
                                <h3>{this.renderKeyData("name", oneKey)}</h3>
                              </FormGroup>

                              <FormGroup indentation="sm">
                                {this.renderKeyData("prices", oneKey)}
                              </FormGroup>
                            </CardNew>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(3, 1fr)",
                              // gridTemplateRows: '200px 200px',
                              gridColumnGap: "1.6%",
                              gridRowGap: "20px",
                              width: "100%"
                            }}
                          >
                            <div
                              onClick={e => {
                                this.handleURL("newwidget");
                              }}
                            >
                              <CardFlatten icon="gamekey">
                                <h4>Sell via Widget</h4>
                                <p>
                                  Set up an embeddable widget for this game key
                                  package
                                </p>
                              </CardFlatten>
                            </div>

                            <div
                              onClick={e => {
                                this.handleURL("newsite");
                              }}
                            >
                              <CardFlatten>
                                <h4>Sell via Landing Page</h4>
                                <p>
                                  Set up an embeddable widget for this game key
                                  package
                                </p>
                              </CardFlatten>
                            </div>

                            <CardFlatten>
                              <h4>Sell via Direct Link</h4>
                              <p>Copy link</p>
                            </CardFlatten>
                          </div>
                        </div>
                      );
                    })}

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 2fr",
                        // gridTemplateRows: '200px 200px',
                        gridColumnGap: "1.6%",
                        gridRowGap: "20px",
                        width: "100%"
                      }}
                    >
                      {/* <Link to='/game_keys/new'> */}
                      <div
                        style={{
                          width: "100%",
                          height: "200px",
                          cursor: "pointer"
                        }}
                        key={`new_onekey`}
                        onClick={e => {
                          this.handleURL("newkey");
                        }}
                      >
                        <CardFlatten icon="gamekey" title="New Asset" />
                      </div>
                      {/* </Link> */}
                    </div>
                  </div>
                )}
              </FormGroup>
            </FormGroup>
          )}

          {this.state.newKey && (
            <GameKeyWizard_temp
            // handleModal={this.handleModal.bind(this)}
            // newKey={
            //   typeof this.props.newKey !== "undefined"
            //     ? this.props.newKey
            //     : this.state.newKey
            // }
            />
          )}

          {this.state.newWidget && (
            <WidgetWizard
            // handleModal={this.handleModal.bind(this)}
            // newKey={
            //   typeof this.props.newKey !== "undefined"
            //     ? this.props.newKey
            //     : this.state.newKey
            // }
            />
          )}

          {this.state.newSite && (
            <PAsbStartPopup
              handleModal={() => {
                debugger;
                this.props.history.push(`/game_keys/`);
              }}
            />
          )}
        </div>
      );
    }
  }
);

export default PAgkDashboard3;

export const CardFlatten = ({
  children,
  title = "New asset",
  icon = "add",
  ...props
}) => {
  return (
    <div
      className="xsui-card"
      {...props}
      style={{
        background: "#f7faff",
        width: "100%",
        color: "#0073f7",
        boxShadow: "none",
        cursor: "pointer",
        borderRadius: 4,
        border: "1px solid rgba(0,115,247,.32)"
        // display: (align) ? 'grid' : 'block',
        // placeItems: (align) ? 'center center' : 'inherit',
      }}
    >
      {children}

      {!children && (
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
          }}
        >
          <div style={{ marginBottom: 8 }}>
            {icon === "add" && (
              <Button
                appearance="flatten"
                icon={icon}
                style={{ background: "#f7faff" }}
              >
                {" "}
              </Button>
            )}

            {icon === "gamekey" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.4736 11.0106H15.4795V15.0224H33.5323H34.5353H35.5382H36.5412H37.5441H38.547H39.55H40.5529V17.0282H39.55V19.0341H38.547V21.04H37.5441V23.0458H36.5412V25.0517H35.5382V27.0576H34.5353V29.0634H33.5323V31.0693H15.4795V34.0781H29.5206V36.084H15.4795H13.4736V31.0693V15.0224V13.0165H10.4648V11.0106H13.4736ZM15.4795 37.0869H19.4913V41.0987H15.4795V37.0869ZM25.5089 37.0869H29.5206V41.0987H25.5089V37.0869Z"
                  fill="#0073F7"
                />
              </svg>
            )}

            {icon === "login" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M39.0566 9.92054H41.2078V41.1133V42.1889H20.7712V40.0377V31.4328H22.9224V40.0377H39.0566V12.0718H22.9224V18.5254H20.7712V9.92054H22.9224H39.0566ZM25.0736 17.4498H26.1492V19.601H26.687H26.1492V18.5254H27.2248V19.601H26.687H28.3005V20.6767H29.3761V21.7523H30.4517V23.9035H30.9895H30.4517V22.8279H31.5273V23.9035H30.9895H32.6029V26.0547H31.5273V27.1303H30.4517V28.2059H29.3761V29.2815H28.3005V30.3572H27.2248V31.4328H26.1492V32.5084H25.0736V33.584H23.998V32.5084V30.3572H8.93945V19.601H23.998V17.4498V16.3742H25.0736V17.4498ZM33.6785 22.8279H32.6029V21.7523H31.5273V20.6767H30.4517V19.601H29.3761V18.5254H28.3005V17.4498H27.2248V16.3742H26.1492V15.2986H23.998V13.1474H37.981V15.2986V16.3742V17.4498V18.5254V19.601V20.6767V21.7523V22.8279V24.9791V27.1303V28.2059V29.2815V30.3572V31.4328V32.5084V33.584V34.6596V38.962H23.998V34.6596H26.1492V33.584H27.2248V32.5084H28.3005V31.4328H29.3761V30.3572H30.4517V29.2815H31.5273V28.2059H32.6029V27.1303H33.6785V24.9791V22.8279Z"
                  fill="#0073F7"
                />
              </svg>
            )}

            {icon === "launcher" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M41.1125 24.9791H42.1882V31.4328H41.1125H38.9613V22.8279H41.1125V24.9791ZM10.9955 31.4328H9.91992V24.9791H10.9955V22.8279H13.1467V31.4328H10.9955ZM35.7345 34.6596H37.8857V35.7352H14.2224V34.6596H16.3736V32.5084H35.7345V34.6596ZM22.8272 10.9962V9.92054H29.2809V10.9962H31.4321V12.0718H33.5833V13.1474H35.7345V16.3742H37.8857V20.6767H14.2224V16.3742H16.3736V13.1474H18.5248V12.0718H20.676V10.9962H22.8272ZM37.8857 21.7523V31.4328H14.2224V21.7523H37.8857ZM24.9784 36.8108H27.1296V42.1889H24.9784V36.8108ZM21.7516 36.8108H23.9028V41.1133H21.7516V36.8108ZM18.5248 36.8108H20.676V38.962H18.5248V36.8108ZM28.2053 36.8108H30.3565V41.1133H28.2053V36.8108ZM31.4321 36.8108H33.5833V38.962H31.4321V36.8108Z"
                  fill="#0073F7"
                />
              </svg>
            )}

            {icon === "site" && (
              <svg
                width={52}
                height={52}
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.8451 13.8447H21.1708V21.1705H13.8451V13.8447ZM13.8451 22.3915H21.1708V29.7173H13.8451V22.3915ZM22.3918 13.8447H29.7176V21.1705H22.3918V13.8447ZM22.3918 22.3915H29.7176V29.7173H22.3918V22.3915ZM30.9386 13.8447H38.2643V21.1705H30.9386V13.8447ZM30.9386 22.3915H38.2643V29.7173H30.9386V22.3915ZM13.8451 30.9382H21.1708V38.264H13.8451V30.9382ZM22.3918 30.9382H29.7176V38.264H22.3918V30.9382ZM30.9386 30.9382H38.2643V38.264H30.9386V30.9382ZM7.74023 7.73991H12.6241V12.6238H7.74023V7.73991ZM7.74023 39.485H12.6241V44.3688H7.74023V39.485ZM39.4853 7.73991H44.3692V12.6238H39.4853V7.73991ZM39.4853 39.485H44.3692V44.3688H39.4853V39.485Z"
                  fill="#0073F7"
                />
              </svg>
            )}
          </div>

          <Button appearance="flatten" style={{ textTransform: "uppercase" }}>
            {title}
          </Button>
        </div>
      )}
    </div>
  );
};
